import { render } from "./InvalidList.vue?vue&type=template&id=8795932c&scoped=true"
import script from "./InvalidList.vue?vue&type=script&lang=js"
export * from "./InvalidList.vue?vue&type=script&lang=js"

import "./InvalidList.vue?vue&type=style&index=0&id=8795932c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8795932c"]])

export default __exports__